<template lang="pug">
  r-form(
    ref='form'
    submit-text='crear'
    title='Crear sucursal'
    v-bind='formProps'
    v-model='gBranchOffice'
    @reset='submitReset'
    @submit='submitCreate'
    )
</template>

<script>
  //
  import { RForm } from '@/components/reusable_components/next'
  import TranslatorService from '@/services/translator'
  //
  import GBranchOfficeFields from '@/views/General/GBranchOffice/GBranchOfficeFields'
  import GBranchOfficeModel from '@/models/General/GBranchOffice'
  //
  export default {
    components: {
      RForm,
    },
    computed: {
      formProps() {
        return {
          fields: GBranchOfficeFields,
        }
      }
    },
    data() {
      return {
        gBranchOffice: new GBranchOfficeModel({
          address: '',
          branch_office_sii: '',
          email: '',
          g_commune_id: '',
          name: '',
          phone: '',
        }),
      }
    },
    methods: {
      showCreateError(event) {
        this.$toast.error(TranslatorService(GBranchOfficeModel, event.response.data))
      },
      showCreateSuccess() {
        this.$toast.success('Sucursal creada exitosamente')
      },
      submitCreate() {
        return this
          .toWait(true)
          .then(this.toCreate)
          .then(this.toWait)
      },
      submitReset() {
        this.gBranchOffice.address = ''
        this.gBranchOffice.branch_office_sii = ''
        this.gBranchOffice.email = ''
        this.gBranchOffice.g_commune_id = ''
        this.gBranchOffice.name = ''
        this.gBranchOffice.phone = ''
      },
      toCreate() {
        return this
          .gBranchOffice
          .toCreate()
          .save()
          .then(this.showCreateSuccess)
          .then(this.toRedirect)
          .catch(this.showCreateError)
      },
      toRedirect() {
        this.$router.push({ name: 'g-branch-office-list' })
      },
      toWait(value = false) {
        return this.$refs.form.setWait(value)
      },
    },
    created() {
      this.setTitle('Crear sucursal')
    },
  }
</script>